export default "__VITE_ASSET__D8L_VfIw__"